package decoders

import bitmage.hex
import htmlEscape
import veryLargeDataFieldThreshold

object JWT: ByteWitchDecoder {
    override val name = "JWT"
    private val validator = Regex("^[A-Z0-9\\-_=]+\\.[A-Z0-9\\-_=]+\\.[A-Z0-9\\-_=]+$", RegexOption.IGNORE_CASE)

    override fun confidence(data: ByteArray, sourceOffset: Int): Pair<Double, ByteWitchResult?> {
        // JWTs should be reasonably sized
        if(data.size > veryLargeDataFieldThreshold)
            return Pair(0.0, null)

        val string = data.decodeToString()
        if(string matches validator) {
            return Pair(1.0, null)
        }
        return Pair(0.0, null)
    }

    override fun decode(data: ByteArray, sourceOffset: Int, inlineDisplay: Boolean): ByteWitchResult {
        val string = data.decodeToString()
        val parts = string.split(".")

        check(parts.size == 3){ "unexpected number of JWT parts: ${parts.size}" }

        val decoded = parts.map { ByteWitch.decodeBase64(it) }

        check(decoded[0].isNotEmpty() && decoded[1].isNotEmpty())

        val headerEnd = sourceOffset + parts[0].encodeToByteArray().size
        val payloadEnd = headerEnd + 1 + parts[1].encodeToByteArray().size
        val header = BWString(decoded[0].decodeToString(), Pair(sourceOffset, headerEnd))
        val payload = BWString(decoded[1].decodeToString(), Pair(headerEnd+1, payloadEnd))
        val signature = BWAnnotatedData("", decoded[2], Pair(payloadEnd+1, sourceOffset+data.size))

        return JWTResult(header, payload, signature, Pair(sourceOffset, sourceOffset+data.size))
    }


}

data class JWTResult(
    val header: BWString,
    val payload: BWString,
    val signature: BWAnnotatedData,
    override val sourceByteRange: Pair<Int, Int>
) : ByteWitchResult {
    override val colour = ByteWitchResult.Colour.GENERIC
    override fun renderHTML(): String {
        return "<div class=\"roundbox generic\" $byteRangeDataTags>${header.renderHTML()} ${payload.renderHTML()} ${signature.renderHTML()}</div>"
    }
}